export const PREPROD_API_BASE_URL = "https://preprod-api.getmethere.in";
export const PROD_API_BASE_URL = "https://api.getmethere.in";
const API_BASE_URL_STORAGE_KEY = "apiBaseUrl";

export const getApiBaseUrl = () => {
  if (process.env.REACT_APP_API_BASE_URL === PROD_API_BASE_URL) {
    localStorage.removeItem(API_BASE_URL_STORAGE_KEY);
    return PROD_API_BASE_URL;
  }

  return (
    localStorage.getItem(API_BASE_URL_STORAGE_KEY) ||
    process.env.REACT_APP_API_BASE_URL ||
    PREPROD_API_BASE_URL
  );
};

export const setApiBaseUrl = (url: string) => {
  localStorage.setItem(API_BASE_URL_STORAGE_KEY, url);
};
